<template>
  <div>
    <v-btn icon dark color="color1" @click="add1Year">
      1Y
    </v-btn>
    <v-btn icon dark color="color1" @click="add6Months">
      6M
    </v-btn>
  </div>
</template>

<script>
export default {
  props: ['expiryDate'],
  computed: {
    localExpiryDate: {
      get () {
        return this.expiryDate
      },
      set (nv) {
        this.$emit('update:expiryDate', nv)
      }
    }
  },
  methods: {
    add1Year () {
      this.localExpiryDate = this.$moment().add(1, 'years').format('YYYY-MM-DD')
    },
    add6Months () {
      this.localExpiryDate = this.$moment().add(6, 'months').format('YYYY-MM-DD')
    }
  }
}
</script>
